
import registrationService from '../registration-hosting-service.js';
import FormulaAssetsInfo from '@/components/formula-assets-info/formula-assets-info.vue';
export default {
  components: {
    FormulaAssetsInfo
  },
  data() {
    return {
      id: '', // 标的id
      projectInfo: {},
      notice_time: '', // 公告时间
      type: 0, // 判断是转让还是采购
      transaction: {}, // 流转详情
      bidInfo: {detail: []}
    };
  },
  created() {
    this.id = this.$route.query.id;
  },
  mounted() {
    this.getNoticeDetail();
  },
  methods: {
    getNoticeDetail() {
      let params = {
        id: this.id
      };
      registrationService.selectListById(params).then(res => {
        if (res && res.code === '0') {
          this.projectInfo = res.data;
        }
      });
    },
    openWindow (url) {
      window.open(url);
    }
  }
};
